import React from 'react';
interface ActionButtonsProps {
  onReset: () => void;
  onSave: () => void;
}
export function ActionButtons({
  onReset,
  onSave
}: ActionButtonsProps) {
  return <div className="flex flex-col justify-center gap-4 sm:flex-row" data-id="element-10">
      <button onClick={onReset} className="rounded-xl px-12 py-4 font-bold text-white shadow-md transition-all hover:shadow-lg" style={{
      backgroundColor: '#374151'
    }} onMouseEnter={e => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.backgroundColor = '#1F2937';
    }} onMouseLeave={e => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.backgroundColor = '#374151';
    }} data-id="element-11">
        Réinitialiser
      </button>
      <button onClick={onSave} className="rounded-xl px-12 py-4 font-bold text-white shadow-md transition-all hover:shadow-lg" style={{
      backgroundColor: '#6B4423'
    }} onMouseEnter={e => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.backgroundColor = '#553619';
    }} onMouseLeave={e => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.backgroundColor = '#6B4423';
    }} data-id="element-12">
        Sauvegarder la Matrice
      </button>
    </div>;
}